(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    

/*
  LULUMI Footer Image Lightbox
*/

(function () {

  function initLulumiFooterLightbox() {

    const footer = document.querySelector('.footer-content');

    if (!footer) return;

    const images = footer.querySelectorAll(
      ':nth-child(4) img'
    );

    if (!images.length) return;

    let lightbox =
      document.querySelector(
        '.lulumi-image-lightbox'
      );

    if (!lightbox) {

      lightbox =
        document.createElement('div');

      lightbox.className =
        'lulumi-image-lightbox';

      lightbox.innerHTML = `
        <button
          class="lulumi-image-lightbox-close"
          aria-label="Close image"
          type="button"
        >
          ×
        </button>

        <img
          src=""
          alt=""
        >
      `;

      document.body.appendChild(
        lightbox
      );
    }

    const lightboxImage =
      lightbox.querySelector('img');

    const closeButton =
      lightbox.querySelector(
        '.lulumi-image-lightbox-close'
      );


    images.forEach(function (image) {

      if (
        image.dataset.lulumiLightbox ===
        'true'
      ) {
        return;
      }

      image.dataset.lulumiLightbox =
        'true';


      image.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          event.stopPropagation();

          lightboxImage.src =
            image.currentSrc ||
            image.src;

          lightboxImage.alt =
            image.alt || '';

          lightbox.classList.add(
            'is-open'
          );

          document.body.style.overflow =
            'hidden';

        }
      );

    });


    function closeLightbox() {

      lightbox.classList.remove(
        'is-open'
      );

      document.body.style.overflow =
        '';

      lightboxImage.src = '';
    }


    closeButton.addEventListener(
      'click',
      function (event) {

        event.stopPropagation();

        closeLightbox();

      }
    );


    lightbox.addEventListener(
      'click',
      function (event) {

        if (
          event.target === lightbox
        ) {

          closeLightbox();

        }

      }
    );


    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape'
        ) {

          closeLightbox();

        }

      }
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initLulumiFooterLightbox
    );

  } else {

    initLulumiFooterLightbox();

  }

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
